class RegexConstants {
    static firstName  = /^[a-zA-Z\s]{4,}$/;
    static lastName  = /^[a-zA-Z\s]{4,}$/;
    static phone = /^[0]?[6-9][0-9]{9}$/;
    static email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,7})+$/;
    static website = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$/;
}

export default RegexConstants;
